import axios from 'axios';
import { baseURL, environment } from '../../../api/environment';

const URL = baseURL;

/**
 * Registra la transacción enviada a Vicomm
 */
export const tranEnviadaVicomm = async ({ commit, rootState }, params) => {
    try {
        commit('SET_LOADING', true);
        const env = environment.ENV;
        
        const endpoint = env === 'production' 
            ? 'https://481vwlnrk7.execute-api.us-east-1.amazonaws.com/Prod/tranEnviadaVicomm'
            : 'https://481vwlnrk7.execute-api.us-east-1.amazonaws.com/dev/tranEnviadaVicomm';
        
        console.log('Vicomm - Ambiente:', env);
        console.log('Vicomm - Endpoint:', endpoint);
        
        const token = await rootState.Token.token.dataObj;
        
        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'post',
            baseURL: URL,
            responseType: 'json',
            headers: {
                'Authorization': token
            },
            data: {
                "cliente": params.cliente,
                "orderId": params.orderId,
                "canalPago": params.canalPago,
                "correo": params.correo,
                "telefono": params.telefono,
                "nombre": params.nombre,
                "monto": params.monto,
                "canalOrigen": params.canalOrigen,
                "idConcepto": ""
            }
        });
        
        commit('SET_Tran_Enviada_ViComm', data);
        return data;
    } catch (err) {
        console.error('❌ Vicomm Enviada Error:', err.message);
    } finally {
        commit('SET_LOADING', false);
    }
};

/**
 * Registra la transacción recibida de Vicomm
 */
export const tranEnviadaVicomm2 = async ({ commit, rootState }, params) => {
    try {
        commit('SET_LOADING', true);
        const env = environment.ENV;
        
        const endpoint = env === 'production' 
            ? 'https://481vwlnrk7.execute-api.us-east-1.amazonaws.com/Prod/tranRecibidaVicomm'
            : 'https://481vwlnrk7.execute-api.us-east-1.amazonaws.com/dev/tranRecibidaVicomm';
        
        console.log('Vicomm - Ambiente:', env);
        console.log('Vicomm - Endpoint:', endpoint);
        
        const token = await rootState.Token.token.dataObj;
        
        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'post',
            baseURL: URL,
            responseType: 'json',
            headers: {
                'Authorization': token
            },
            data: {
                "cliente": params.cliente,
                "orderId": params.orderId,
                "canalPago": params.canalPago,
                "currentStatus": params.currentStatus,
                "authCode": params.authCode,
                "monto": params.monto,
                "reference": params.reference,
                "productDesc": params.productDesc,
                "canalOrigen": params.canalOrigen,
                "idConcepto": ""
            }
        });
        
        commit('SET_Tran_Enviada_ViComm2', data);
        return data;
    } catch (err) {
        console.error('❌ Vicomm Recibida Error:', err.message);
    } finally {
        commit('SET_LOADING', false);
    }
};
